import React from 'react'
import Link from 'gatsby-link'
import { Container, Row, Col } from 'reactstrap';

import MouseSVG from '../components/MouseSvg';
import Contact from '../components/ContactForm';
import LogoSvg from '../components/LogoSvg';
import './index.scss';

class IndexPage extends React.Component {

	constructor(props) {
		super(props);  

    this.state = {
			slideStart: false,
			textSlideStart: false,
			mouseFade: false,
			scrolledPast: '',
			headingFadeIn: '',
    };

		this.handleScroll = this.handleScroll.bind(this);

	}

	handleScroll(event) {
		(window.pageYOffset < 50)
			? this.setState({ headingFadeIn: '' })
			:  this.setState({ headingFadeIn: 'fade-in' });
		(window.pageYOffset < 280)
			? this.setState({ scrolledPast: '' })
			:  this.setState({ scrolledPast: 'transparent' });
		// console.log("main scrolly: ", window.pageYOffset);
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
		// console.log("main page scrollPos?: ", this.props.scrollPos);
		setTimeout(() => {
			this.setState({ slideStart: true });
		}, 1500);
		setTimeout(() => {
			this.setState({ textSlideStart: true });
		}, 2200);
		setTimeout(() => {
			this.setState({ mouseFade: true });
		}, 3000);
	}
	
	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

  render() {
    const { location, title } = this.props
    return (
			<div className="main-page-global">
				<div className={`left-slide-in ${ this.state.slideStart ? 'slide' : '' }`}></div>
				<div className={`right-slide-in ${ this.state.slideStart ? 'slide' : '' }`}></div>
				<div className="main-page-background"></div>
				<div className="clear-top-box-no-overflow">
					<div className={`opaque-top-box-container ${ this.state.slideStart ? 'slide' : '' } ${ this.state.scrolledPast }`}>
						<div className={`logo-large ${ this.state.textSlideStart ? 'text-slide' : '' }`} >
							<LogoSvg width="300px" />
						</div>
					</div>
				</div>
				<div className="clear-bottom-box-no-overflow">
					<div className={`opaque-bottom-box-container ${ this.state.slideStart ? 'slide' : '' }`}></div>
					<img src={require('./img/committed.svg')} className={`committed ${ this.state.textSlideStart ? 'text-slide' : ''}`} />
					<div className={`bottom-text-right ${ this.state.textSlideStart ? 'text-slide' : '' }`}>
						"Taking pride in bringing a sense of family to our practice."
					</div>
					<div className={`mouse-div ${ this.state.mouseFade ? 'text-slide' : '' }`}>
						<MouseSVG />
					</div>
					<div name="about" id="about"></div>
				</div>
				<div className="areas-about-wrap" id="aboutHead" >
					<Container  id="home2">
						<div id="about2" className={`heading-box about ${this.state.headingFadeIn}`}>
							<span>About S&amp;R, PC</span>
						</div>
						<div className="three-areas-flex">
							<div className="three-areas-img-outer finance">
								<div className="dummy-height"></div>
								<span className="three-areas-text">PUBLIC FINANCE</span>
							</div>
							<div className="three-areas-img-outer municipal">
								<div className="dummy-height"></div>
								<span className="three-areas-text">MUNICIPAL GOVERNMENT</span>
							</div>
							<div className="three-areas-img-outer civil">
								<div className="dummy-height"></div>
								<span className="three-areas-text">CIVIL LAW</span> {/*  this will need to be abs 0,0,0,0 */}
							</div>
						</div>
						<div className="areas-about-text-block">
							<h2>About Strawn &amp; Richardson, PC</h2>
							<p>
								Strawn &amp; Richardson, P.C. is a small law firm specializing in the representation of Municipal Utility Districts (MUDs) in the greater Houston, Texas area.  We currently represent districts in Harris, Fort Bend, Galveston, Brazoria and Montgomery Counties.  We take pride in bringing a sense of family to our practice.  
							</p>
							<p>
								As general counsel to our clients, we prepare, file and manage all documents for utility districts, including notices and minutes of public meetings; we conduct public meetings in accordance with the Texas Open Meetings Act. We keep records and respond to requests for information in accordance with the Texas Public Information Act. We represent utility districts in connection with regulatory matters before the Texas Commission on Environmental Quality (TCEQ), the Texas Water Development Board (TWDB), and other state and local agencies. We handle all aspects of directors elections, bond elections and special elections, in accordance with state and federal law.  We advise our districts regarding all general operating matters, including creation, annexations, taxation, and legislative matters. We draft and negotiate contracts between municipal entities involving financing, construction and maintenance of utility facilities. We represent and advise our districts in connection with litigation, including eminent domain and condemnation, pollution and hazardous substance issues, and contractual disputes. We represent utility districts in alternative dispute resolution (ADR) procedures, including mediation and arbitration.
							</p>
							<p>
								As bond counsel to our clients, we handle all aspects of issuance of municipal bonds, securing transcript approval from the Texas Attorney General and rendering bond opinions on federal tax exemption and on state law matters. As members of the National Association of Bond Lawyers (NABL), we secure the issuance of new money and refunding bonds on behalf of our municipal utility district clients.
							</p>
						</div>
						<div name="attorneys" id="attorneys"></div>
					</Container>
				</div>
				<div className="our-attorneys-wrap">
					<svg id="curveDownColor" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
						<path d="M0 0 C 50 100 80 100 100 0 Z"/>
					</svg>
					<Container className="attorneys-container">
						<div id="attorneys2" className="heading-box attorneys">
							<span>Our Attorneys</span>
						</div>
						<Row className="strawn-row">
							<Col lg='12' className="">
								<img src={require('./img/sue_strawn_headshot.jpg')} style={{ width: '200px' }} className="bio-headshots" />
								{/* <div className="bio-text-wrap"> */}
									<h3>Sue Strawn</h3>
									<p>
										Sue Strawn has represented Municipal Utility Districts throughout her distinguished career. She graduated from Rice University in 1970 and the University of Houston Law Center in 1977.  Sue began representing water districts in 1978 while at the firm of Leonard, Koehn, Rose, Webb & Hurt.  In 1983, she became a shareholder, and the firm was renamed Leonard, Koehn, Hurt, Schweinle, Strawn & Ingoldsby.  In 1991, she joined the firm of Sewell & Riggs as a shareholder.  In 1996, she joined the firm of Schweinle, Parish, Lowerre & Strawn as a shareholder.  In 1999, Sue Strawn and Chris Richardson created their own firm, Strawn & Richardson, P.C.  Sue is semi-retired but remains active as an attorney.
									</p>
								{/* </div> */}
							</Col>
						</Row>
						<Row className="richardson-row">
							<Col lg='12' className="">
								<img src={require('./img/c_rich_headshot.jpg')} style={{ width: '200px' }} className="bio-headshots" />
								{/* <div className="bio-text-wrap"> */}
									<h3>Christopher Richardson</h3>
									<p>
										Chris Richardson graduated from Bellaire High School in 1987, earning a National Merit Academic Scholarship to the University of Texas.  He graduated from UT in 1991 and the University of Houston Law Center in 1995.  Chris began representing water districts in 1996 while at the firm of Schweinle, Parish, Lowerre & Strawn.  In 1999, Chris joined Sue to form Strawn & Richardson, P.C.  Chris lives in Katy with his wife and their two young sons.
									</p>
								{/* </div> */}
							</Col>
						</Row>
					</Container>
					<svg id="curveUpColor" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
						<path d="M0 100 C 20 0 50 0 100 100 Z"/>
					</svg>
					<div name="contact" id="contact"></div>
				</div>
				<div className="location-wrap">
					<Container>
						<div id="contact2" className="heading-box location">
							<span>Contact</span>
						</div>
						{/* 20200912 turn off form. something wrong with recaptcha.
							<Row>
							<Col lg='4' sm='12' className="location-image-col">
								<div className="location-contact-img" ></div>
							</Col>
							<Col lg='8' sm='12' className="location-form-col">
								<Contact />
							</Col>
						</Row>*/}
						<Row>
							<Col lg='12' className="location-map">
								<div className="location-map-dummy"></div>
								<div className="location-ph-addr-box">
									<div className='location-ph-addr-inner-wrap'>
										<div className="location-addr-wrap">
											<div className="office-left-img">
												<img src={require('./img/pin-white.svg')} />
											</div>
											<div className="office-right-address">
												<p>
													1155 Dairy Ashford Road, Suite 875<br/>
													Houston, TX 77079
												</p>
											</div>
										</div>
										<div className="location-ph-wrap">
											<div className="office-left-img">
												<img src={require('./img/phone-white.svg')} />
											</div>
											<div className="office-right-phone">
												<p>
													(713) 864-5466
												</p>
											</div>
										</div>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			</div>
		)
	}
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js